import Bookedslots from "../slotsbooked/Bookedslots";

import './css/pickup.css';

const Pickup = () => {
    return ( 
        <div className="pickup">
            <Bookedslots />
        </div>
     );
}
 
export default Pickup;